import About from "../components/About";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

function AboutPage() {
  return (
    <>
      <SEO
        title="About Us | KMC Health (Kitmeechai Health)"
        description="KMC Health (Kitmeechai Health) is an integrated health system enabler, redefining a future-forward healthcare via integrating health promotion and specific disease management that proactively shape better health and wellbeing for everyone, everywhere."
        path="/about"
      />
      <About />
      <Footer />
    </>
  );
}

export default AboutPage;